export const UPDATE_INSTITUTION_TABLE = {
  UPDATE_INSTITUTION_TABLE_REQUEST: 'UPDATE_INSTITUTION_TABLE_REQUEST',
  UPDATE_INSTITUTION_TABLE_SUCCESS: 'UPDATE_INSTITUTION_TABLE_SUCCESS',
  UPDATE_INSTITUTION_TABLE_FAILED: 'UPDATE_INSTITUTION_TABLE_FAILED',
};
